/** @format */

import React from "react";
import SwiperCore, {
  Autoplay,
  EffectCoverflow,
  EffectCreative,
  EffectFade,
  Pagination,
  Navigation,
} from "swiper";
import "swiper/swiper.min.css";
import "swiper/css/pagination";
import {
  Swiper as SwiperReact,
  SwiperSlide as SwiperSlideReact,
} from "swiper/react";
import { SwiperProps, SwiperRef } from "swiper/react/swiper-react";
import "swiper/scss";

SwiperCore.use([EffectCoverflow, Pagination, EffectCreative, Autoplay]);

export function Swiper(
  props: {
    slides: any[];
    swiperModules?: string[];
  } & React.RefAttributes<SwiperRef> &
    SwiperProps
) {
  const { slides = [], swiperModules = [], ...rest } = props;
  const modules = [];

  swiperModules.forEach((m) => {
    if (m === Pagination.name) modules.push(Pagination);
    if (m === Autoplay.name) modules.push(Autoplay);
    if (m === EffectFade.name) modules.push(EffectFade);
  });
  return (
    <SwiperReact modules={modules} {...rest}>
      {slides.map((slide) => (
        <SwiperSlideReact key={slide.key}>{slide}</SwiperSlideReact>
      ))}
    </SwiperReact>
  );
}

export {
  Autoplay,
  EffectCoverflow,
  EffectCreative,
  EffectFade,
  Pagination,
  Navigation,
};
